/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { z } from "zod";
const base = z.object({
  id: z.number(),
  createdAt: z.number(),
  updatedAt: z.number(),
  material_division_id: z.number(),
  material_id: z.number(),
  detail_name: z.string(),
  package_form: z.string(),
  shelf_life_months: z.number().nullable(),
  content_quantity: z.number().nullable(),
  content_unit: z.string(),
  sort_order: z.number(),
  specific_gravity: z.number().nullable(),
  hazardous_class: z.string().nullable(),
  deleted_at: z.number().nullable(),
});
const create = base.extend({
});
const update = base.partial();
const put = create.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
});
const patch = base.omit({
  createdAt: true,
  updatedAt: true,
  deleted_at: true,
})
.extend({ id: z.number() })
const rows = z.array(base);
const rowsWithPaging = z.object({
  count: z.number(),
  rows: rows,
});
const cache = base.omit({
}).extend({ cachedAt: z.number() });
const caches = z.array(cache);
export const MaterialDetailBaseSchema = { base, put, patch, rows, rowsWithPaging, create, update, cache, caches };
export type MaterialDetailBase = z.infer<typeof base>;
export type MaterialDetailBasePutPayload = z.infer<typeof put>;
export type MaterialDetailBasePatchPayload = z.infer<typeof patch>;
export type MaterialDetailBaseRowsWithPaging = z.infer<typeof rowsWithPaging>;
export type MaterialDetailBaseCreateAttributes = z.infer<typeof create>;
export type MaterialDetailBaseUpdateAttributes = z.infer<typeof update>;
export type MaterialDetailBaseCacheAttributes = z.infer<typeof cache>;
export type MaterialDetailBaseCachesAttributes = z.infer<typeof caches>;